<p #content>
	<span [innerHtml]="textToShow"></span>
	<a *ngIf="isCollapsable" (click)="toggle()">{{ isExpanded ? readLess : readMore }}</a>
</p>
